import type {
  AdminDegenPrizeScanInput,
  AdminDegenPrizeScanResult,
} from '@rb/shared/admin-degen-prize.types';
import { AdminRPCClient } from '@/client/rpc-client';

/** 디젠 상금 원장 스캔 — 서버가 커서 페이징·합계·state 대사 데이터까지 계산한다. */
export async function adminScanDegenPrizeLog(
  input: AdminDegenPrizeScanInput
): Promise<AdminDegenPrizeScanResult> {
  return AdminRPCClient.call<AdminDegenPrizeScanResult>('adminDegenPrize.scanPrizeLog', [input]);
}
